import { combineReducers } from 'redux'

import { reducer as appAlertReducer } from '../modules/appAlert/reducer'
import { reducer as autoSaveReducer } from '../modules/autoSave/reducer'
import { reducer as labraChatReducer } from '../modules/labraChat/reducer'
import { reducer as loadingReducer } from '../modules/loading/reducer'
import { UserProfileReducer } from '../modules/userProfile/reducer'

export const commonReducerMap = {
  loading: loadingReducer,
  appAlert: appAlertReducer,
  autoSave: autoSaveReducer,
  userProfile: UserProfileReducer,
  labraChat: labraChatReducer,
} as const

export const commonRootReducer = combineReducers(commonReducerMap)

export type CommonRootState = ReturnType<typeof commonRootReducer>
